import React__default from 'react';
import { g as getChannelTitle } from '../../chunks/bundle-Bvt5IYi6.js';
import { u as useLocalization } from '../../chunks/bundle-s19NuPaM.js';
import { G as GroupChannelListItemView } from '../../chunks/bundle-fqvqMG6F.js';
import { u as useGroupChannelList } from '../../chunks/bundle-oEMCMrvU.js';
import { u as useSendbird } from '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Ca6003_X.js';
import '../../chunks/bundle-DUxsnVl5.js';
import '../../chunks/bundle-DUh4gAyx.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-BVK-TCRK.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DDAJSpJT.js';
import '../../chunks/bundle-DrrIZ2Uk.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '../../chunks/bundle-yAJ3x9FL.js';
import '../../chunks/bundle-CGyTyL9F.js';
import '../../chunks/bundle-CCadcyYR.js';
import '../../chunks/bundle-CPSJLEbT.js';
import '../../GroupChannel/components/TypingIndicator.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../ui/Badge.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-zHBlW_wn.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../chunks/bundle-DMGc5oMP.js';
import '../../ui/MentionUserLabel.js';
import '../../chunks/bundle-DgkSQIK-.js';
import '../../chunks/bundle-CCo7ZdMR.js';
import 'react-dom';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DMyARZj7.js';
import '../../chunks/bundle-DvAn8oVD.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-C6mXReBM.js';
import '../../chunks/bundle-CFtiiXEl.js';
import '../../chunks/bundle-CiiVQ3uH.js';

var GroupChannelListItem = function (_a) {
    var _b, _c, _d;
    var channel = _a.channel, isSelected = _a.isSelected, isTyping = _a.isTyping, renderChannelAction = _a.renderChannelAction, onLeaveChannel = _a.onLeaveChannel, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var config = useSendbird().state.config;
    var stringSet = useLocalization().stringSet;
    var _e = useGroupChannelList().state, isTypingIndicatorEnabled = _e.isTypingIndicatorEnabled, isMessageReceiptStatusEnabled = _e.isMessageReceiptStatusEnabled;
    var userId = config.userId;
    var isMessageStatusEnabled = isMessageReceiptStatusEnabled
        && (!((_b = channel.lastMessage) === null || _b === void 0 ? void 0 : _b.isAdminMessage()))
        && ((_d = (_c = channel.lastMessage) === null || _c === void 0 ? void 0 : _c.sender) === null || _d === void 0 ? void 0 : _d.userId) === userId;
    return (React__default.createElement(GroupChannelListItemView, { channel: channel, tabIndex: tabIndex, channelName: getChannelTitle(channel, userId, stringSet), isTyping: isTypingIndicatorEnabled && isTyping, isSelected: isSelected, isMessageStatusEnabled: isMessageStatusEnabled, onClick: onClick, onLeaveChannel: onLeaveChannel, renderChannelAction: renderChannelAction }));
};

export { GroupChannelListItem };
//# sourceMappingURL=GroupChannelListItem.js.map
